<app-overlay *ngIf="carregando"></app-overlay>
<div *ngIf="exibirApp">
  <app-header></app-header>
  <main>
    <router-outlet *ngIf="!loading"></router-outlet>
  </main>
  <app-footer *ngIf="!router.url.includes('ecommerce')"></app-footer>
</div>
<h5 *ngIf="exibirErro">Erro ao obter as configurações</h5>